import { LoadingButton } from "@mui/lab";
import { Button, Stack, StackProps } from "@mui/material";

export interface ActionProps {
  onCancel?: () => void;
  cancelText?: string;
  loading?: boolean;
  disabled?: boolean;
  confirmText?: string;
  stackProps?: StackProps;
}

export interface FormActionButtonProps extends ActionProps {
  type: "form";
}

export interface StandardActionButtonProps extends ActionProps {
  type: "standard";
  onConfirm: () => void;
}

export type ActionButtonsProps = FormActionButtonProps | StandardActionButtonProps;

export function ActionButtons(props: ActionButtonsProps) {
  const { confirmText = "Confirm", cancelText = "Cancel", onCancel, type, loading, disabled, stackProps } = props;

  const isForm = type === "form";
  return (
    <Stack justifyContent="flex-end" direction="row" spacing={2} padding={2} {...stackProps}>
      {cancelText && onCancel && (
        <Button size="small" onClick={onCancel}>
          {cancelText}
        </Button>
      )}

      <LoadingButton
        size="small"
        variant="contained"
        type={isForm ? "submit" : "button"}
        loading={loading}
        disabled={disabled}
        onClick={() => {
          if (type === "standard") {
            props.onConfirm();
          }
        }}
      >
        {confirmText}
      </LoadingButton>
    </Stack>
  );
}
